"use client";

import Cookies from "js-cookie";
import { useRouter } from "next/router";
import { clearLastKnownAuthToken } from "queries/constants";
import { useCurrentUser } from "queries/current-user";
import { useCallback, useMemo } from "react";
import { SESSION_KEY } from "ui/lib/constants";
import { isDev } from "ui/lib/helpers";

export const sectionLinks = [
  { name: "Calendar", href: "overview" },
  {
    name: "Chat",
    href: "chat?useFlagFilter=true",
    // Phones open on the full inbox, unread first; flags are a chip there.
    phoneHref: "chat",
    onlyCurrentCoachesTeam: true,
  },
  { name: "Movements", href: "movements" },
  { name: "Team Details", href: "details", adminOnly: true },
];

export const useSectionLinks = () => {
  const { isAdmin, isCoachesTeam } = useCurrentUser();

  return useMemo(
    () =>
      sectionLinks.filter(({ adminOnly, onlyCurrentCoachesTeam }) => {
        if (isAdmin) return true;
        if (adminOnly) return false;
        if (onlyCurrentCoachesTeam && !isCoachesTeam) return false;
        return true;
      }),
    [isAdmin, isCoachesTeam]
  );
};

// Section hrefs carry a query string; the pathname segment is what marks one active.
export const sectionSegment = (href) => href.split("?")[0];

const toolLinks = [
  { name: "Blocks", href: "/blocks", coachVisible: true },
  { name: "Open Season", href: "/open-season" },
  { name: "Curated Rooms", href: "/curated-rooms" },
  { name: "Home Shelves", href: "/home-shelves" },
  { name: "Remote Config", href: "/remote-config" },
  { name: "Ladder Links", href: "/links/builder" },
  { name: "Promo Codes", href: "/promos" },
  {
    name: "Partnerships",
    href: `${isDev ? "https://dev.joinladder.com" : "https://www.joinladder.com"}/app/internal/partnerships`,
    external: true,
  },
  { name: "Badges", href: "/badges" },
];

export const useToolLinks = () => {
  const { isAdmin, isCoach } = useCurrentUser();

  return useMemo(() => {
    if (isAdmin) return toolLinks;
    if (isCoach) return toolLinks.filter(({ coachVisible }) => coachVisible);
    return [];
  }, [isAdmin, isCoach]);
};

export const useSignOut = () => {
  const { push } = useRouter();

  return useCallback(() => {
    Cookies.remove(SESSION_KEY);
    // SPA navigation, no reload — clear the axios client's in-memory token
    // fallback or this tab keeps authenticating after logout.
    clearLastKnownAuthToken();
    push("/", "/");
  }, [push]);
};
